<template>
  <div v-if="list.length > 0">
    <div class="title">
      Unknown Fields
    </div>
    <v-row class="mt-4" :no-gutters="$root.isMobile">
      <v-col cols="12" sm="6" v-for="(item, i) in list" :key="i">
        <div class="body-2">
          {{ item.name }}
        </div>
        <div class="subtitle-1 font-weight-bold">{{ item.value }}</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    list() {
      let list = [];
      let vm = this;
      if (vm.item && vm.item.unknownFields) {
        Object.keys(vm.item.unknownFields).forEach(key => {
          let value = vm.item.unknownFields[key];
          list.push({
            name: key.replace(/_/g, " "),
            value
          });
        });
      }
      return list;
    }
  }
};
</script>

<style></style>
